import { sendGAMTrackerEvent } from "_services/api/engagement";

const GAMTracker = () => {
	return null;
};

const getServerSideProps = async context => {

	const params = context.query;

	try {
		await sendGAMTrackerEvent ( params );
	} catch ( err ) {
		// not sure if anything needs to done
	}

	return {
		props: {
			noAuth      : true,
			noLayout    : true,
			noAnalytics : true
		}
	};
};

export { getServerSideProps };

export default GAMTracker;
